(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vehicle-related-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vv-vehicle-matches')) {
    customElements.define('vv-vehicle-matches', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.loaded) return;
        this.dataset.loaded = 'true';
        this.loadMatches();
      }

      async loadMatches() {
        const url = new URL(this.dataset.searchUrl, window.location.origin);

const modeloBase = this.dataset.modelo
  .replace(/\s+\d{4}(?:-\d{4})?\+?$/, '')
  .trim();

url.searchParams.set(
  'q',
  `${this.dataset.marca} ${modeloBase}`
);

url.searchParams.set('type', 'product');
url.searchParams.set('options[prefix]', 'last');
url.searchParams.set('options[unavailable_products]', 'show');
url.searchParams.set('section_id', this.dataset.sectionId);

        try {
          const response = await fetch(url.toString());
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const template = html.querySelector('template[data-vehicle-matches]');
          if (!template) throw new Error('Missing vehicle matches template');

          const normalize = (value) =>
  String(value || '').trim().toLowerCase();

const parseList = (value) => {
  if (!value) return [];

  try {
    const parsed = JSON.parse(value);

    if (Array.isArray(parsed)) {
      return parsed.map(normalize);
    }

    return [normalize(parsed)];
  } catch (error) {
    return [normalize(value)];
  }
};

const wantedMarca = normalize(this.dataset.marca);
const wantedModelo = normalize(this.dataset.modelo);
const wantedMedida = normalize(this.dataset.medida);

const seen = new Set([this.dataset.productId]);
const fragment = document.createDocumentFragment();
let count = 0;

const compatibles = [];

for (
  const item of template.content.querySelectorAll(
    '[data-product-id]'
  )
) {
  const id = item.dataset.productId;

  if (!id || seen.has(id)) continue;

  const marcas = parseList(item.dataset.marca);
  const modelos = parseList(item.dataset.modelo);
  const medidas = parseList(item.dataset.medida);

  if (!marcas.includes(wantedMarca)) continue;
  if (!modelos.includes(wantedModelo)) continue;
  if (!medidas.includes(wantedMedida)) continue;

  seen.add(id);
  compatibles.push(item);
}

compatibles.sort((a, b) => {
  const aPaso = a.textContent
    .toLowerCase()
    .includes('paso de ruedas');

  const bPaso = b.textContent
    .toLowerCase()
    .includes('paso de ruedas');

  if (aPaso === bPaso) return 0;

  return aPaso ? 1 : -1;
});

for (const item of compatibles.slice(0, 5)) {
  fragment.append(item.cloneNode(true));
  count += 1;
}

          if (count > 0 && this.isConnected) {
            this.querySelector('.vehicle-related-products__grid').replaceChildren(fragment);
            this.hidden = false;
          }
        } catch (error) {
          console.error('VanVerse: error loading vehicle matches', error);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
